'use client'

import { type ElementType } from 'react'
import * as AriakitMenu from '@ariakit/react/menu'
import Button from '../Button/Button'

interface MenuItemProps extends AriakitMenu.MenuItemProps {
  icon?: ElementType
  iconColor?: string
  [key: string]: any
}
export function MenuItem ({ children, icon: Icon, iconColor, ...props }: MenuItemProps) {
  return (
    <AriakitMenu.MenuItem render={props.render ?? <Button variant='flat' style={{ width: 'unset', justifyContent: 'start', fontWeight: 'normal', borderRadius: 7 }} />} {...props}>
      {Icon ? <Icon size={16} width={16} style={{ color: iconColor }} /> : null}
      {children}
    </AriakitMenu.MenuItem>
  )
}
